/*
 * @Author: lizhigang
 * @Date: 2025-11-03 18:10:58
 * @Company: www.smm.cn
 * @Description: 通用声明
 */

// smm cookie 默认 key
export const COOKIE_DEFAULT_KEY = "SMM_auth_token"

// 临时 token cookie 默认 key
export const COOKIE_TEMPORARY_KEY = "SMM_temporary_auth_token"

export const SIGN_IN_EN_WEB_SOURCE_MAP: Record<string, string> = {
  "news.metal.com": "metal.news",
  "data-pro.metal.com": "metal.data-pro",
  "www.metal.com": "metal.www",
  "user.metal.com": "metal.user",
  "history.metal.com": "metal.price",
  "publications.metal.com": "metal.publications",
  "buy.metal.com": "metal.buy",
  "car.meta.com": "metal.car",
  "multilingual.metal.com": "metal.multi",
}

export const SIGN_IN_EN_H5_SOURCE_MAP: Record<string, string> = {
  "news.metal.com": "metal.h5.news",
  "www.metal.com": "metal.h5.www",
  "user.metal.com": "metal.h5.user",
  "publications.metal.com": "metal.h5.publications",
  "buy.metal.com": "metal.h5.buy",
  "price-m.metal.com": "metal.h5.price",
  "www-m.metal.com": "metal.h5.www",
}
